var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReplace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M18.4,16.1l-1.5.2c1.8-1.9,2.8-4.5,2.6-7.2C19.1,4,14.6.1,9.5.5c-.4,0-.7.4-.7.8s.4.7.8.7c4.3-.3,8.1,3,8.4,7.3.2,2.4-.7,4.6-2.3,6.1v-1.6c0-.4-.4-.7-.8-.7s-.8.4-.8.8l.2,3.8h0c0,.1,0,.2.2.3h.3c.1,0,0,0,0,0l3.8-.5c.4,0,.7-.4.6-.8,0-.4-.4-.7-.8-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M10.7,17.7c-2.2.2-4.2-.6-5.7-1.9-1.5-1.3-2.5-3.2-2.7-5.4-.2-2.6.9-5,2.8-6.6v1.5c0,.5.4.7.8.7s.8-.4.8-.8l-.2-3.8h0c0-.1,0-.2-.2-.3h-.3c-.1,0,0,0,0,0l-3.8.5c-.4,0-.7.4-.6.8,0,.4.4.7.8.6l1.6-.2C1.8,4.7.6,7.5.8,10.5c.2,2.5,1.3,4.8,3.2,6.4,1.9,1.6,4.3,2.4,6.8,2.3.4,0,.7-.4.7-.8s-.4-.7-.8-.7Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplace);
export default __webpack_public_path__ + "static/media/replace.b22e24232f55759f87c6e18b18dba582.svg";
export { ForwardRef as ReactComponent };